import { IconsProps } from '../icon-types';
import { SvgWrapper } from '../svg-wrapper/icon-wrapper';

export function GeoLocationIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <path
        fill="inherit"
        d="M22 2L12 22l-2.276-7.726L2 12.003z"
        fillRule="evenodd"
      />
    </SvgWrapper>
  );
}
